"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_config_1 = require("react-router-config");
const react_router_dom_1 = require("react-router-dom");
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const Dropdown_1 = __importDefault(require("../atoms/Dropdown"));
const Tooltip_1 = __importDefault(require("../atoms/Tooltip"));
const DataLayerLabels_1 = __importDefault(require("../enums/DataLayerLabels"));
const TooltipPosition_1 = __importDefault(require("../enums/TooltipPosition"));
const dataLayer_1 = require("../helper/dataLayer");
const path_1 = require("../helper/path");
const ResellerAreaNavigationStore_1 = __importDefault(require("../stores/ResellerAreaNavigationStore"));
class TabsNavigation extends react_1.default.Component {
    // @ts-expect-error Dropdown cannot be used as type.
    tabDropdownRef = {};
    tabDropdownLabelRef = {};
    showDropdown = null;
    tabsRef = react_1.default.createRef();
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            showDropdown: mobx_1.observable,
            setShowDropdown: mobx_1.action.bound,
            resetShowDropdown: mobx_1.action.bound,
            updateDropdownPositions: mobx_1.action.bound,
        });
    }
    componentDidMount() {
        document.addEventListener('scroll', this.updateDropdownPositions);
        document.addEventListener('click', this.resetShowDropdown);
    }
    componentWillUnmount() {
        document.removeEventListener('click', this.resetShowDropdown);
        document.removeEventListener('scroll', this.updateDropdownPositions);
    }
    render() {
        return (react_1.default.createElement("nav", { className: (0, classnames_1.default)('znd-tabs position-sticky', this.props.className), ref: this.tabsRef, onScroll: this.updateDropdownPositions }, this.routes().map((route, index) => {
            const accessAllowed = this.accessAllowed(route);
            return (react_1.default.createElement("div", { key: index, className: "znd-tabs__item-wrapper" }, (route.routes?.length ?? 0) > 0 && accessAllowed
                ? this.renderDropdownNavigationItem(route)
                : this.renderSimpleNavigationItem(route, accessAllowed, index)));
        })));
    }
    renderSimpleNavigationItem(route, accessAllowed, index) {
        if (!accessAllowed) {
            return (react_1.default.createElement(Tooltip_1.default
            // Position is set to leftCenter or rightCenter as otherwise the tooltip would be
            // outside the tab navigation and therefore hidden.
            , { 
                // Position is set to leftCenter or rightCenter as otherwise the tooltip would be
                // outside the tab navigation and therefore hidden.
                position: [0, 1].includes(index) ? TooltipPosition_1.default.rightCenter : TooltipPosition_1.default.leftCenter, label: (0, translation_1.t)(route.tabNavigationForbiddenTooltipKey ?? 'navigation.permission_denied'), className: "znd-tabs__tooltip" },
                react_1.default.createElement("span", { className: this.routeClassName(route, accessAllowed) }, (0, translation_1.t)(this.routeTranslationKey(route)))));
        }
        return (react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(route.path), className: this.routeClassName(route, accessAllowed), onClick: () => {
                (0, dataLayer_1.pushToDataLayerNavigation)({
                    [DataLayerLabels_1.default.dlvNavigationLevelOne]: (0, translation_1.t)(this.routeMainNavigationTranslationKey(route)),
                    [DataLayerLabels_1.default.dlvNavigationLevelTwo]: (0, translation_1.t)(this.routeTranslationKey(route)),
                });
            } }, (0, translation_1.t)(this.routeTranslationKey(route))));
    }
    renderDropdownNavigationItem(route) {
        if (!this.tabDropdownRef[route.path]) {
            this.tabDropdownRef[route.path] = react_1.default.createRef();
            this.tabDropdownLabelRef[route.path] = react_1.default.createRef();
        }
        const currentMatch = (0, react_router_config_1.matchRoutes)([route, ...(route.routes ?? [])], this.props.location.pathname)[0];
        const tabIsActive = route.path === currentMatch?.match.path;
        const dropdownRef = this.tabDropdownRef[route.path];
        const dropdownLabelRef = this.tabDropdownLabelRef[route.path];
        const rootCategoryClasses = (0, classnames_1.default)('znd-tabs__item', {
            'znd-tabs__item--active': !!currentMatch,
        });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { ref: dropdownLabelRef, className: rootCategoryClasses, onClick: (event) => {
                    this.setShowDropdown(route.path, event);
                } },
                (0, translation_1.t)(this.routeTranslationKey(route)),
                react_1.default.createElement(Icon_1.default, { name: Zupicons_1.default.angleDown, className: "znd-tabs__arrow" })),
            react_1.default.createElement(Dropdown_1.default, { show: route.path === this.showDropdown, ref: dropdownRef },
                ResellerAreaNavigationStore_1.default.needsNavigationItem(route.resellerNavigationItem.pathname) ? (react_1.default.createElement(react_router_dom_1.Link, { to: (0, path_1.localePath)(route.path), className: (0, classnames_1.default)('znd-dropdown__item', {
                        'znd-dropdown__item--active': tabIsActive,
                    }), onClick: (event) => {
                        this.resetShowDropdown(event);
                    } }, (0, translation_1.t)(this.routeTranslationKey(route)))) : null,
                route.routes?.map((subRoute) => (react_1.default.createElement(react_router_dom_1.Link, { key: subRoute.path, to: (0, path_1.localePath)(subRoute.path), className: (0, classnames_1.default)('znd-dropdown__item', {
                        'znd-dropdown__item--active': currentMatch?.match.path === subRoute.path,
                    }), onClick: (event) => {
                        this.resetShowDropdown(event);
                    } }, (0, translation_1.t)(this.routeTranslationKey(subRoute))))))));
    }
    routeTranslationKey(route) {
        return (route.tabNavigationLabel ??
            (route.translationKey ?? route.path.substring(1).replace(':locale/', '').replace(/\//g, '.')) + '.title');
    }
    routeMainNavigationTranslationKey(route) {
        const translationKey = this.routeTranslationKey(route);
        return 'navigation.' + translationKey.substring(0, translationKey.indexOf('.')) + '.title';
    }
    routeClassName(route, accessAllowed) {
        return (0, classnames_1.default)('znd-tabs__item', {
            'znd-tabs__item--active': accessAllowed && this.routesWithoutParameter(route),
            'text-muted': !accessAllowed,
        });
    }
    routesWithoutParameter(route) {
        return this.props.location.pathname.indexOf((0, path_1.localePath)(route.path)) > -1;
    }
    accessAllowed(route) {
        const scopes = [route?.scope, ...(route?.scopes ?? [])].filter((item) => !!item);
        return AuthorizationStore_1.default.hasScopes(scopes);
    }
    routes() {
        return (this.props.routes ?? [])
            .filter((config) => typeof config.path === 'string')
            .filter((route) => route.path.length > 0 &&
            !(0, path_1.localePath)(route.path).includes(':') &&
            (this.accessAllowed(route) || !!route.tabNavigationShowForbidden));
    }
    setShowDropdown(pathname, event) {
        event?.preventDefault();
        this.showDropdown = pathname ?? null;
        const dropdownInstance = this.tabDropdownRef[pathname ?? '']?.current;
        window.requestAnimationFrame(() => {
            if (!(this.tabsRef.current && pathname && dropdownInstance?.dropdownRef.current)) {
                return;
            }
            const dropdownElement = dropdownInstance.dropdownRef.current;
            const dropdownElementRect = dropdownElement.getBoundingClientRect();
            const dropdownLeft = dropdownElementRect.left;
            const dropdownWidth = dropdownElementRect.width;
            const rootRect = this.tabsRef.current.getBoundingClientRect();
            const rootLeft = rootRect.left;
            const rootWidth = rootRect.width;
            const currentScroll = this.tabsRef.current.scrollLeft;
            const minLeft = 0;
            const maxRight = rootLeft + rootWidth;
            const currentLeft = dropdownLeft;
            const currentRight = currentLeft + dropdownWidth;
            let scrollOffset = 0;
            if (currentRight > maxRight) {
                scrollOffset = maxRight - currentRight;
            }
            else if (currentLeft < minLeft) {
                scrollOffset = minLeft - currentLeft;
            }
            const newScroll = currentScroll - scrollOffset;
            if (this.tabsRef.current.scrollTo) {
                this.tabsRef.current.scrollTo({
                    behavior: 'smooth',
                    left: newScroll,
                });
            }
            else {
                this.tabsRef.current.scrollLeft = newScroll;
            }
        });
    }
    resetShowDropdown(event) {
        if (!(event.target instanceof HTMLElement)) {
            return;
        }
        const target = event.target;
        if (Object.values(this.tabDropdownLabelRef).some((ref) => !!ref?.current && ref.current.contains(target))) {
            return;
        }
        this.setShowDropdown();
    }
    updateDropdownPositions() {
        Object.values(this.tabDropdownRef).forEach((dropdownRef) => {
            dropdownRef.current?.updatePosition();
        });
    }
}
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(TabsNavigation));
